import { formatToCompanyTimezone, formatToUtc, getDateTimeFromSelectedDate, getYearFromCompanyDate } from "../lib/functions";
import dayjs from 'dayjs';
import Big from "big.js";
import { bigMul, bigPercent, toBig } from "../lib/bigConversion";

export const createSalesPharmaPayload = (
    customer,
    itemsList,
    footerValues,
    taxMode,
    prevDues,
    employee,
    selectedSalesAcc,
    selectedDiscountAcc,
    selectedTaxAcc,
    selectedTransportAcc,
    tag_field_id,
    insuranceCompanyId,
    selectedDoctorId,
    patientCopayPercent,
    patientDueAmount,
    insuranceDueAmount,
    entryDate,
    isEditMode,
    isTatmeenProduct,
    ssccCode
) => {
    console.log("========== createSalesPharmaPayload Params ==========");

    console.log("customer:", customer);
    console.log("itemsList:", itemsList);
    console.log("footerValues:", footerValues);
    console.log("taxMode:", taxMode);
    console.log("prevDues:", prevDues);
    console.log("employee:", employee);
    console.log("selectedSalesAcc:", selectedSalesAcc);
    console.log("selectedDiscountAcc:", selectedDiscountAcc);
    console.log("selectedTaxAcc:", selectedTaxAcc);
    console.log("selectedTransportAcc:", selectedTransportAcc);
    console.log("tag_field_id:", tag_field_id);
    console.log("insuranceCompanyId:", insuranceCompanyId);
    console.log("selectedDoctorId:", selectedDoctorId);
    console.log("patientCopayPercent:", patientCopayPercent);
    console.log("patientDueAmount:", patientDueAmount);
    console.log("insuranceDueAmount:", insuranceDueAmount);
    console.log("entryDate:", entryDate);

    console.log(
        "isTatmeenProduct:",
        isTatmeenProduct,
        "| type:",
        typeof isTatmeenProduct
    );

    console.log(
        "ssccCode:",
        ssccCode,
        "| type:",
        typeof ssccCode
    );

    console.log("==============================================");

    const { discountAmount, taxAmount, grandTotal, dueAmount, totalSubtotal } =
        calculateTotals(taxMode, itemsList, footerValues);

    // convert selected/entry Date to utc date + time
    let finalEntryDate = entryDate;
    if (!dayjs(entryDate).isSame(dayjs(), "day")) {
        finalEntryDate = getDateTimeFromSelectedDate(entryDate); // Merge date + current time in TZ

    } else {
        finalEntryDate = entryDate; // Use now in TZ
    }

    let dateUTC = formatToUtc(finalEntryDate);

    let companydate = formatToCompanyTimezone(dateUTC);
    const vchYear = getYearFromCompanyDate(companydate);


    const items = mapItems(
        itemsList,
        taxMode,
        selectedDiscountAcc,
        selectedTaxAcc,
        selectedTransportAcc
    );
    const payCart = footerValues?.payCart ? mapPayCart(footerValues?.payCart) : [];
    const payServiceCart = footerValues?.payServiceCart
        ? mapAddExpensesCart(footerValues?.payServiceCart)
        : [];

    const prevDueBig = new Big(prevDues || 0);
    const grandTotalBig = new Big(grandTotal || 0);
    const dueBig = new Big(dueAmount || 0);

    const emis = footerValues?.emis ? mapEmis(footerValues?.emis) : [];

    const other_service_cost = payServiceCart?.reduce(
        (sum, item) => new Big(sum).plus(new Big(item?.tran_amount || 0)),
        new Big(0)
    );

    const msg = `Dear ${customer.acc_name}, Your Bill Amount is ${grandTotalBig.toFixed(2)} (${footerValues?.salesVoucherNumber
        }), Bill Paid Amount: ${footerValues?.paidAmount || 0}, Bill Due Amount: ${dueBig.toFixed(2)}, Your Previous Due is ${prevDueBig.toFixed(2)} & Current Due is ${prevDueBig.plus(dueBig).toFixed(2)
        }.`;

    return {
        sale_id: 0,
        orderId: 0,
        vchdate: vchYear,

        customer: {
            acc_id: customer.acc_id,
            acc_name: customer.acc_name,
            institution_name: customer.institution_name || null,
            contact_no: customer.contact_no,
            country_code: customer.country_code || null,
            address: customer.address || null,
        },
        itemCart: items,
        emis: emis,
        emi_month: footerValues?.emiMonths || 0,
        payCart: payCart,
        payServiceCart: payServiceCart,
        insuranceData: {
            insurance_id: insuranceCompanyId,
            ...(selectedDoctorId ? { doctor_id: selectedDoctorId } : {}),
            copay_amount: patientCopayPercent,
            patient_amt: patientDueAmount,
            insurance_amount: insuranceDueAmount,
        },
        is_smg: "yes",
        msg: msg,
        masterData: {
            is_tatmeen_product: isTatmeenProduct ? 1 : 0,
            sscc_code: ssccCode || "",
            sale_voucher_no: footerValues?.salesVoucherNumber,
            is_condition_sale: "no",
            is_serial: "no",
            is_cal_type: taxMode === "individual" ? taxMode : "on_total",
            created_date: formatToUtc(finalEntryDate),
            narration: footerValues?.description || "",
            challan_text: footerValues?.challanText || "",
            sub_total: totalSubtotal,
            // total_discount: taxMode === "individual" ? items.reduce((sum, i) => sum + (i.item_discount || 0), 0) : discountAmount || 0,
            total_discount:
                taxMode === "individual"
                    ? items.reduce(
                        (sum, i) => sum + Number(i.item_discount || 0),
                        0
                    )
                    : Number(discountAmount || 0),
            total_discount_per: footerValues?.discountPercent || 0,
            // total_tax: taxMode === "individual" ? items.reduce((sum, i) => sum + (i.item_tax || 0), 0) : taxAmount || 0,
            total_tax:
                taxMode === "individual"
                    ? items.reduce(
                        (sum, i) => sum + Number(i.item_tax || 0),
                        0
                    )
                    : Number(taxAmount || 0),
            total_tax_per: footerValues?.taxPercent || 0,
            total_transport_cost: footerValues?.transportCost || 0,
            total_amount: grandTotal,
            paid_amount: footerValues?.paidAmount || 0,
            due_amount: dueAmount,
            due_date: dueAmount > 0 ? footerValues?.dueDate : null,
            is_emi: emis.length > 0 ? "yes" : "no",
            emi_month: footerValues?.emiMonths || 0,
            day_week: footerValues?.emiDayWeek || 0,
            emi_amount: footerValues?.emiAmount || 0,
            employee_id: employee,
            sales_acc_id: selectedSalesAcc?.acc_id || null,
            discount_acc_id: selectedDiscountAcc?.acc_id || null,
            tax_acc_id: selectedTaxAcc?.acc_id || null,
            transport_acc_id: selectedTransportAcc?.acc_id || null,
            cus_po_ref: null,
            other_service_cost: other_service_cost,
            conversion_rate: footerValues?.conversion_rate || 0,
            conversion_currency: footerValues?.conversion_currency || null,
            ...(tag_field_id?.length > 0 ? { tag_field_id } : {}),
            ...(insuranceCompanyId && {
                insurance_id: insuranceCompanyId,
                ...(selectedDoctorId ? { doctor_id: selectedDoctorId } : {}),
                copay_amount: patientCopayPercent,
                patient_amt: patientDueAmount,
                insurance_amount: insuranceDueAmount,
            }),
        },
    };
};


export const mapItems = (
    itemList,
    taxMode,
    selectedDiscountAcc,
    selectedTaxAcc,
    selectedTransportAcc
) => {
    const items = itemList?.map((el) => {

        const isBonus = !!el?.bonus;

        const qty = toBig(el.quantity);
        const rate = isBonus ? toBig(0) : toBig(el.rate);

        const discountPer = isBonus ? 0 : Number(el.discount_per) || 0;
        const vatPer = isBonus ? 0 : Number(el.vat_per) || 0;

        const lineAmount = bigMul(qty, rate);
        const discountAmt = bigPercent(lineAmount, discountPer);
        const afterDiscount = toBig(lineAmount).minus(discountAmt);
        const taxAmt = bigPercent(afterDiscount, vatPer);

        const itemTotal =
            isBonus
                ? new Big(0)
                : taxMode === "individual"
                    ? afterDiscount.plus(taxAmt)
                    : toBig(lineAmount);

        return {
            sale_d_id: el?.sale_d_id || null,
            warehouse_id: 0,
            warehouse_name: "",
            item_id: el?.product?.item_id,
            item_name: el?.product?.item_name,
            display_text: el?.product?.display_text,
            item_description: el?.item_description || "",
            is_serial: el.product.is_serial,
            item_qty: qty,
            item_rate: rate,
            item_discount_per: discountPer,
            item_discount: isBonus ? 0 : discountAmt,
            discount_acc_id: selectedDiscountAcc.acc_id,
            discount_acc_name: selectedDiscountAcc.acc_name,
            item_tax_per: vatPer,
            item_tax: isBonus ? 0 : taxAmt,
            tax_acc_id: selectedTaxAcc.acc_id,
            tax_acc_name: selectedTaxAcc.acc_name,
            serials: el.selectedSerials || [],
            serial_mode: el.serial_mode || "unit",
            child_sscc_code: el.child_sscc_code || "",
            is_tatmeen_required: el.is_tatmeen_required === true ? true : false,
            item_total: toBig(itemTotal).toString(),
            retail_qty: 0,
            sale_qty: toBig(el.quantity).times(el.product.conversion).toString(),
            sale_rate:
                el?.product?.conversion > 1
                    ? rate / el.product.conversion
                    : rate,
            qty_display:
                el.quantity +
                " " +
                el?.product.unit_symbol +
                (el?.product.conversion > 1
                    ? ", " + el.retail_qty + " " + el.base_unit_name
                    : ""),
            unit_symbol: el?.product.unit_symbol,
            base_unit_name: el?.product.base_unit_name,
            unit_name: el?.product.unit_name,
            conversion: el?.product.conversion,
            purchase_average_rate: Number(el?.itemInfo?.average_rate) || 0,
            units: el?.product.units,
            per_unit_symbol: el?.product.unit_symbol,
            per_conversion: el?.product.conversion,
            per_unit_id: el?.product.unit_id,
            bounus_update_check: el?.bonus ? el?.bonus : false,

            ...(el.batch_id && {
                selected_batch_expiry: el.batch_expiry,
                selected_batch_id: el.batch_id,
                selected_batch: el.batch_name,
            }),
            ...(el.packing_name && el.packing_quantity && {
                packing_name: el.packing_name,
                packing_quantity: el.packing_quantity,
                packing_name_quantity: el.packing_name_quantity,
            }),
        };
    });
    return items;
};

export const mapPayCart = (payCart) => {
    const result = payCart?.map((el, index) => {
        return {
            to_acc_id: el?.from_acc_id,
            acc_type_id: el?.acc_type_id,
            date: el?.date,
            to_acc_name: el?.from_acc_name,
            tran_amount: el?.tran_amount,
            cheque_number: el?.cheque_number || null,
            expected_bank_acc_id: el?.expected_bank_acc_id || null,
        };
    });
    return result;
};

export const mapEmis = (emis) => {
    const result = emis?.map((el) => {
        return {
            emi_no: el?.emiNo,
            from_date: el?.fromDate,
            last_date: el?.lastPayDate,
            amount: el?.amount,
        };
    });
    return result;
};

export const mapAddExpensesCart = (payServiceCart) => {
    const result = payServiceCart?.map((el) => {
        return {
            to_acc_id: el.to_acc_id,
            acc_type_id: el.acc_type_id,
            to_acc_name: el.to_acc_name,
            tran_amount: el?.tran_amount,
        };
    });
    return result;
};

export const calculateTotals = (taxMode, dataSource, footerValues) => {
    let totalSubtotal = new Big(0);

    if (taxMode === "individual") {
        dataSource.forEach((item) => {
            if (item?.bonus) return totalSubtotal;

            const discountPercent = toBig(item.discount_per || 0);
            const vatPercent = toBig(item.vat_per || 0);
            const qtyBig = toBig(item.quantity);
            const rateBig = toBig(item.rate);

            const line = bigMul(qtyBig, rateBig);
            const discount = bigPercent(line, discountPercent);
            const afterDiscount = toBig(line).minus(discount);
            const vat = bigPercent(afterDiscount, vatPercent);

            totalSubtotal = totalSubtotal.plus(afterDiscount.plus(vat));

            // const discountAmount =
            //   (item.discount_per / 100) * item.quantity * item.rate;
            // const rowTotal = item.quantity * item.rate - discountAmount;
            // const vatAmount = (item.vat_per / 100) * rowTotal;
            // totalSubtotal += rowTotal + vatAmount;

        });
    } else {
        totalSubtotal = dataSource?.reduce((sum, item) => {
            if (item?.bonus) return sum;

            const qtyBig = toBig(item.quantity);
            const rateBig = toBig(item.rate);

            return sum.plus(qtyBig.times(rateBig));
        }, new Big(0));
    }

    const totalServiceCharge = Array.isArray(footerValues?.payServiceCart)
        ? footerValues.payServiceCart.reduce(
            (sum, item) => new Big(sum).plus(item?.tran_amount || 0),
            new Big(0)
        )
        : 0;

    const discountAmount =
        taxMode === "total"
            ? totalSubtotal.times(footerValues?.discountPercent || 0).div(100)
            : new Big(0);
    const totalAfterDiscount = totalSubtotal.minus(discountAmount);
    const taxAmount =
        taxMode === "total"
            ? totalAfterDiscount.times(footerValues?.taxPercent || 0).div(100)
            : new Big(0);
    const totalIncludingTax = totalAfterDiscount.plus(taxAmount);

    // const grandTotal = totalIncludingTax + footerValues?.serviceCharge;
    const grandTotal = totalIncludingTax.plus(totalServiceCharge);
    let due = grandTotal.minus(
        new Big(footerValues?.paidAmount || 0)
    );

    // to avoid dues below 0.01 values
    if (due.abs().lt(0.01)) {
        due = new Big(0);
    }

    return {
        totalSubtotal: totalSubtotal.toString(),
        discountAmount: discountAmount.toString(),
        taxAmount: taxAmount.toString(),
        grandTotal: grandTotal.toString(),
        dueAmount: due.toString()
    };
};
